import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { KioskHomeComponent } from './kiosk-home/kiosk-home.component';
import { KioskResolver } from './resolver/kiosk-resolver';
import { AuthguardGuard } from './authguard/authguard.guard';
import { KioskMovieListComponent } from './kiosk-movie-list/kiosk-movie-list.component';
import { KioskShowTimeComponent } from './kiosk-show-time/kiosk-show-time.component';
import { AddTicketsComponent } from './add-tickets/add-tickets.component';
import { KioskBookingComponent } from './kiosk-booking/kiosk-booking.component';
import { KioskFoodPacksComponent } from './kiosk-food-packs/kiosk-food-packs.component';
import { KioskCheckoutComponent } from './kiosk-checkout/kiosk-checkout.component';
import { KioskPaymentComponent } from './kiosk-payment/kiosk-payment.component';
import { KioskConfirmTicketComponent } from './kiosk-confirm-ticket/kiosk-confirm-ticket.component';
import { KioskConfirmTicketsComponent } from './kiosk-confirmTicket/kiosk-confirm-ticket.component';
import { KioskPickupComponent } from './kiosk-pickup/kiosk-pickup.component';
import { KioskPickupCcodeComponent } from './kiosk-pickup-ccode/kiosk-pickup-ccode.component';
import { KioskPickupCclastnoComponent } from './kiosk-pickup-cclastno/kiosk-pickup-cclastno.component';
import { KioskPickupBarcodeComponent } from './kiosk-pickup-barcode/kiosk-pickup-barcode.component';
import { KioskPickupPnumberComponent } from './kiosk-pickup-pnumber/kiosk-pickup-pnumber.component';
import { KioskPickupPrintComponent } from './kiosk-pickup-print/kiosk-pickup-print.component';
import { GiftcardFindComponent } from './giftcard-find/giftcard-find.component';
import { GiftcardRefillComponent } from './giftcard-refill/giftcard-refill.component';


const routes: Routes =  [
  {
    path: "home/:LocationId",
    component: KioskHomeComponent,
    resolve: { resolveData: KioskResolver },
    canActivate: [AuthguardGuard]
  },
  {
    path: "movie-list/:LocationId",
    component: KioskMovieListComponent,
    resolve: { resolveData: KioskResolver },
    canActivate: [AuthguardGuard]
  },
  {
    path: "show-time/:LocationId",
    component: KioskShowTimeComponent,
    resolve: { resolveData: KioskResolver },
    canActivate: [AuthguardGuard]
  },
  {
    path: "add-tickets/:LocationId",
    component: AddTicketsComponent,
    resolve: { resolveData: KioskResolver },
    canActivate: [AuthguardGuard]
  },
  {
    path: "select-seats/:LocationId",
    component: KioskBookingComponent,
    resolve: { resolveData: KioskResolver },
    canActivate: [AuthguardGuard]
  },
  {
    path: "add-food-packs/:LocationId",
    component: KioskFoodPacksComponent,
    resolve: { resolveData: KioskResolver },
    canActivate: [AuthguardGuard]
  },
  {
    path: "checkout/:LocationId",
    component: KioskCheckoutComponent,
    resolve: { resolveData: KioskResolver },
    canActivate: [AuthguardGuard]
  },
  {
    path: "payment/:LocationId",
    component: KioskPaymentComponent,
    resolve: { resolveData: KioskResolver },
    canActivate: [AuthguardGuard]
  },
  {
    path: "confirm-tickets/:LocationId",
    component: KioskConfirmTicketComponent,
    resolve: { resolveData: KioskResolver },
    canActivate: [AuthguardGuard]
  },
  {
    path: "confirmTickets/:LocationId",
    component: KioskConfirmTicketsComponent,
    resolve: { resolveData: KioskResolver },
    canActivate: [AuthguardGuard]
  },
  {
    path: "pickup/:LocationId",
    component: KioskPickupComponent,
    canActivate: [AuthguardGuard],
  },
  {
    path: "pickup/ccode/:LocationId",
    component: KioskPickupCcodeComponent,
    canActivate: [AuthguardGuard],
  },
  {
    path: "pickup/cclastno/:LocationId",
    component: KioskPickupCclastnoComponent,
    canActivate: [AuthguardGuard],
  },
  {
    path: "pickup/barcode/:LocationId",
    component: KioskPickupBarcodeComponent,
    canActivate: [AuthguardGuard],
  },
  {
    path: "pickup/phonenumber/:LocationId",
    component: KioskPickupPnumberComponent,
    canActivate: [AuthguardGuard],
  },
  {
    path: "pickup/print/:LocationId",
    component: KioskPickupPrintComponent,
    canActivate: [AuthguardGuard],
  },
  {
    path: "giftcard",
    component: GiftcardFindComponent,
    canActivate: [AuthguardGuard],
  },
  {
    path: "giftcard/:CardNumber",
    component: GiftcardRefillComponent,
    canActivate: [AuthguardGuard],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class KioskRoutingModule { }


/*
Copyright 2017-2018 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/